var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ak-stacked-window",
    {
      attrs: {
        showClose: false,
        width: _vm.width,
        minWidth: _vm.minWidth,
        resizable: true,
      },
      on: { resize: _vm.updateWidth, close: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "ak-form" },
        [
          _c("ak-loader", {
            staticClass: "ak-form__loader",
            attrs: { loading: _vm.loading },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", { staticClass: "ak-form__header" }, [
                _c("h1", { staticClass: "ak-form__title" }, [
                  _vm._v(_vm._s(_vm.$t("Statistieken voor")) + " "),
                  _c("b", [_vm._v(" " + _vm._s(_vm.title))]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", { staticClass: "ak-form__fields" }, [
                _c("div", { staticClass: "p-t-xs-20 p-b-xs-20" }, [
                  _c("p", [
                    _c("b", [_vm._v(_vm._s(_vm.$t("Algemene statistieken")))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ak-stats" }, [
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Kliks")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("number")(_vm.stats.clicks)) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Unieke kliks")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("number")(_vm.stats.clicks_unique)) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Impressies")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("number")(_vm.stats.impressions)) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Unieke impressies")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("number")(_vm.stats.impressions_unique)
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Weergaves")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("number")(_vm.stats.views)) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Unieke weergaves")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("number")(_vm.stats.views_unique)) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("CTR impressies")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("number")(_vm.stats.ctr, { precision: 2 })
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ak-stat" }, [
                      _c("div", { staticClass: "ak-stat__label" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("CTR weergaves")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ak-stat__value" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("number")(_vm.stats.ctr_views, {
                                precision: 2,
                              })
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "p-t-xs-20" }, [
                  _c("p", [_c("b", [_vm._v("Statistieken per afbeelding:")])]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ak-data-list__items",
                      staticStyle: {
                        "--data-list-item-width": "200px",
                        "--card-top-padding": "0",
                        "--card-bottom-padding": "15px",
                        gap: "15px",
                      },
                    },
                    _vm._l(_vm.statsByMedia, function (mediaStats) {
                      return _c("ak-card", {
                        key: mediaStats.id,
                        attrs: {
                          title: mediaStats.filename,
                          img: mediaStats.url,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "bottom",
                              fn: function () {
                                return [
                                  mediaStats.deleted
                                    ? _c("p", [
                                        _c("span", { staticClass: "muted" }, [
                                          _vm._v(
                                            "(" +
                                              _vm._s(_vm.$t("Verwijderd")) +
                                              ")"
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ak-stats ak-stats--compact p-b-xs-20",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.$t("Kliks")) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats.clicks
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("Unieke kliks")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats
                                                        .clicks_unique
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.$t("Impressies")) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats
                                                        .impressions
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("Unieke Impressies")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats
                                                        .impressions_unique
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.$t("Weergaves")) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats.views
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("Unieke Weergaves")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats
                                                        .views_unique
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("CTR impressies")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats.ctr,
                                                      { precision: 2 }
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ak-stat ak-stat--compact",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ak-stat__label" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("CTR weergaves")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ak-stat__value ak-stat__value--compact",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("number")(
                                                      mediaStats.stats
                                                        .ctr_views,
                                                      { precision: 2 }
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ak-form__footer" }, [
            _c(
              "div",
              { staticClass: "ak-button-group justify-content-end" },
              [
                _c(
                  "ak-button",
                  {
                    attrs: { disableBackground: true },
                    on: { click: _vm.close },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("Sluiten")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }